import { render } from "./SalaryAndBonuses.vue?vue&type=template&id=49b53c01&scoped=true"
import script from "./SalaryAndBonuses.vue?vue&type=script&lang=js"
export * from "./SalaryAndBonuses.vue?vue&type=script&lang=js"

import "./SalaryAndBonuses.vue?vue&type=style&index=0&id=49b53c01&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b53c01"]])

export default __exports__